import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { AutoCompleteComponent, ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { InventoryService } from '../../services/inventory.service';
import { v_InventoryBus } from '../../models/v_InventoryBus';

@Component({
    selector: 'inventory-selector',
    templateUrl: './inventory-selector.component.html',
    styleUrls: ['./inventory-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InventorySelectorComponent implements OnInit {
    @ViewChild("searchAC") ac: AutoCompleteComponent;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    subs: Subscription;
    @Input() minSearchSize: number = 3;

    clear() {
        this.ac.reset();
    }
    data: v_InventoryBus[];
    advSearchGridData: v_InventoryBus[];
    advSearchOpened: boolean = false;
    constructor(globals: GlobalsService, private svc_data: InventoryService) {

    }
    ngOnInit() {
    }
    filterChange(filter: string) {
        if (filter.toString().length < this.minSearchSize) {
            this.data = [];
            return;
        }
//        if (CommonFunctions.hasValue(this.customerId)) {
            this.setLoading(true);
            this.svc_data.quickSearch(filter).subscribe((data: v_InventoryBus[]) => {
                this.data = data;
                this.setLoading(false);
            });
//        }
    }
    advSearch(refresh: boolean = true) {
        if (refresh === true || !CommonFunctions.hasArrayValue(this.advSearchGridData)) {
            this.svc_data.getAll(true).subscribe((data: v_InventoryBus[]) => {
                this.advSearchGridData = data;
                //            this.setLoading(false);
            });
        }

    }
    setLoading(loading: boolean) {
            this.ac.loading = loading;
    }
    valueChange(value: any) {
//        this.selected.emit(id);
    }
    advSearchOpen() {
        this.advSearchOpened = true;
        this.advSearch(false);
    }
    advSearchClose(code: any) {
        this.advSearchOpened = false;
    }
    advValueChange(e: any) {
    }
}
